export default __webpack_public_path__ + "4464dcf42124f455feb38e36a24d8217.png";